import {
    AccountCreateModel,
    AccountDepositModel,
    AccountModel,
    AccountSearchModel,
    AccountUpdateModel,
    AccountWithMarketsModel,
    BaseSearchResponseModel,
    BinanceCancelOrderRequestModel,
    BinanceCancelOrderResponseModel,
    BinanceCreateModel,
    BinanceDataModel,
    BinanceDealHistoryRequestModel,
    BinanceDealHistoryResponseModel,
    BinanceGetSymbolsForSelectResponseModel,
    BinanceLeverageBracketResponseModel,
    BinanceLeverageResponseModel,
    BinanceMessageResponseModel,
    BinanceSetOrderRequestModel,
    BinanceSetOrderResponseModel,
    BinanceSymbolModel,
    BinanceSymbolsCreateRequestModel,
    BinanceSymbolsDeleteRequestModel,
    BinanceSymbolsForSelectResponseModel,
    BinanceSymbolsGetMinTokenBalanceRequestModel,
    BinanceSymbolsResponseModel,
    BinanceSymbolsUpdateRequestModel,
    BinanceSymbolsUpdateResponseModel,
    BinanceUpdateModel,
    BybitBalanceDto,
    BybitCancelOrderDto,
    BybitChangeLeverageDto,
    BybitCreateDto,
    BybitDataModel,
    BybitDataSearchDto,
    BybitGetInstrumentInfoDto,
    BybitGetOrdersHistoryDto,
    BybitGetPositionDto,
    BybitGetPositionsHistoryDto,
    BybitHardStopAllDto,
    CryptoCalculatorDataModel,
    FuturesCalculatorDataModel,
    PublicRobotsModel,
    RccPriceModel,
    ProposalBodyModel,
    ProposalCandidateModel,
    ProposalCreatedModel,
    ProposalExchange,
    ProposalPreviewModel,
    ProposalRowModel,
    ClientSettingsModel,
    ClientSettingsResultModel,
    BybitOrderHistoryDto,
    BybitOrderIdDto,
    BybitPositionDto,
    BybitPositionHistoryDto,
    BybitRiskLimitsDto,
    BybitSearchDto,
    BybitSendOrderDto,
    BybitStartDto,
    BybitSwitchPositionModeDto,
    BybitSymbolBaseDto,
    BybitSymbolDto,
    BybitSymbolForSelectDto,
    BybitUpdateDto,
    BitgetBalanceDto,
    BitgetCancelOrderDto,
    BitgetChangeLeverageDto,
    BitgetCreateDto,
    BitgetDataModel,
    BitgetDataSearchDto,
    BitgetGetInstrumentInfoDto,
    BitgetGetOrdersHistoryDto,
    BitgetGetPositionDto,
    BitgetGetPositionsHistoryDto,
    BitgetHardStopAllDto,
    BitgetOrderHistoryDto,
    BitgetOrderIdDto,
    BitgetPositionDto,
    BitgetPositionHistoryDto,
    BitgetRiskLimitsDto,
    BitgetSearchDto,
    BitgetSendOrderDto,
    BitgetStartDto,
    BitgetSwitchPositionModeDto,
    BitgetSymbolBaseDto,
    BitgetSymbolDto,
    BitgetSymbolForSelectDto,
    BitgetUpdateDto,
    OkxBalanceDto,
    OkxCancelOrderDto,
    OkxChangeLeverageDto,
    OkxCreateDto,
    OkxDataModel,
    OkxDataSearchDto,
    OkxGetInstrumentInfoDto,
    OkxGetOrdersHistoryDto,
    OkxGetPositionDto,
    OkxGetPositionsHistoryDto,
    OkxHardStopAllDto,
    OkxOrderHistoryDto,
    OkxOrderIdDto,
    OkxPositionDto,
    OkxPositionHistoryDto,
    OkxRiskLimitsDto,
    OkxSearchDto,
    OkxSendOrderDto,
    OkxStartDto,
    OkxSwitchPositionModeDto,
    OkxSymbolBaseDto,
    OkxSymbolDto,
    OkxSymbolForSelectDto,
    OkxUpdateDto,
    ActivePartnerDto,
    EligibilityDto,
    PartnerBonusStatsDto,
    PartnerPayoutDto,
    PartnerRequestDto,
    ReferralClientDto,
    PartnerClientModel,
    PartnerClientTradeModel,
    ReferralPayoutDto,
    ReferralStatsDto,
    StakeLockDto,
    StakingPoolStatsDto,
    StakingStateDto,
    UnstakeResultDto,
    ClaimResultDto,
    ChangeRobotParamsModel,
    DealDto,
    DealsPeriodStatisticDto,
    DealsPeriodStatisticResultDto,
    DealsRequestModel,
    DealsResponseModel,
    DealsSearchDto,
    DealsStatisticSummaryDto,
    LiveTradingResponseModel,
    LoginModel,
    MarketDataStartRequestModel,
    MinTokenBalanceDto,
    PeriodStatisticResponseModel,
    RithmicContractMonthDto,
    RithmicCreateModel,
    RithmicDataModel,
    RithmicDataSearchDto,
    RithmicNativeSymbolDto,
    RithmicStartDto,
    RithmicSymbolBaseDto,
    RithmicSymbolDto,
    RithmicSymbolForSelectDto,
    RithmicUpdateDto,
    TTCreateModel,
    TTDataModel,
    TTDataSearchDto,
    TTStartDto,
    TTSymbolBaseDto,
    TTSymbolDto,
    TTSymbolForSelectDto,
    TTUpdateDto,
    CQGCreateModel,
    CQGDataModel,
    CQGDataSearchDto,
    CQGStartDto,
    CQGSymbolBaseDto,
    CQGSymbolDto,
    CQGSymbolForSelectDto,
    CQGUpdateDto,
    PushPublicKeyDto,
    PushSubscribeDto,
    PushSubscribeResultDto,
    PushUnsubscribeDto,
    StatisticRequestModel,
    StatisticResponseModel,
    TronNonceBodyModel,
    TronNonceModel,
    TronVerifyModel,
    WithdrawStatusRequestModel,
    ArchitectureDiagram,
    BookDraft,
    CommentModel,
    ExchangeSummaryModel,
    AccountSummaryModel,
    MonthlyPointModel,
    PublicDealModel,
} from './models'
import { axiosInstance, instance } from './api.utils'
import { BASE_URL_HTTP } from './api.consts'
import {
    ACCOUNT,
    AUTH,
    BINANCE,
    BINANCE_DEALS,
    BINANCE_NATIVE,
    BINANCE_SYMBOLS,
    BYBIT,
    BYBIT_DEALS,
    BYBIT_NATIVE,
    BYBIT_SYMBOLS,
    BITGET,
    BITGET_DEALS,
    BITGET_NATIVE,
    BITGET_SYMBOLS,
    OKX,
    OKX_DEALS,
    OKX_NATIVE,
    OKX_SYMBOLS,
    REFERRAL,
    PARTNER,
    STAKING,
    PUSH,
    RITHMIC,
    RITHMIC_DEALS,
    RITHMIC_SYMBOLS,
    ARCHITECTURE,
    BOOK,
    TT,
    TT_DEALS,
    TT_SYMBOLS,
    CQG,
    CQG_DEALS,
    CQG_SYMBOLS,
    COMMENTS,
    PUBLIC_REPORT,
} from './uri'

export const AuthService = {
    /** Авторизация */
    login: (data: LoginModel) => {
        const formData = new FormData()
        formData.append('username', data.username)
        formData.append('password', data.password)

        return axiosInstance(instance.post(`/${AUTH}/login`, formData))
    },

    /** Выход из системы */
    logout: () => axiosInstance(instance.delete(`/${AUTH}/logout`)),

    /** Получить nonce */
    getNonce: (data: TronNonceBodyModel) =>
        axiosInstance<TronNonceModel>(instance.post(`/${AUTH}/nonce`, data)),

    /** Верификация подписи tron */
    tronVerify: (data: TronVerifyModel) =>
        axiosInstance(instance.post(`/${AUTH}/tron-verify`, data)),
}

export const AccountService = {
    /** Создать аккаунт */
    create: (data: AccountCreateModel) =>
        axiosInstance<AccountModel>(instance.post(`/${ACCOUNT}`, data)),

    /** Получить текущий аккаунт */
    getMe: () => axiosInstance<AccountModel>(instance.get(`/${ACCOUNT}/me`)),

    /** Получить аккаунт */
    get: (id: number) =>
        axiosInstance<AccountModel>(instance.get(`/${ACCOUNT}/${id}`)),

    /** Изменить аккаунт */
    update: (id: number, data: AccountUpdateModel) =>
        axiosInstance<AccountModel>(instance.put(`/${ACCOUNT}/${id}`, data)),

    /** Сменить отображаемый ник (пустая строка = сброс на tron-адрес) */
    setNickname: (nickname: string) =>
        axiosInstance<AccountModel>(
            instance.put(`/${ACCOUNT}/nickname`, { nickname })
        ),

    /** Одноразово привязать реферера (ссылка друга) — необратимо */
    setReferrer: (referrerId: number) =>
        axiosInstance<AccountModel>(
            instance.put(`/${ACCOUNT}/referrer`, { referrerId })
        ),

    /** Получить аккаунты с фильтром */
    search: (skip: number, limit: number, data: AccountSearchModel) =>
        axiosInstance<BaseSearchResponseModel<AccountWithMarketsModel>>(
            instance.post(`/${ACCOUNT}/${skip}/${limit}`, data)
        ),

    /** Подтвердить пополнение: сервер сверяется с блокчейном и зачисляет */
    deposit: () =>
        axiosInstance<{ deposit: number; credited: number; amount: number }>(
            instance.post(`/${ACCOUNT}/deposit`)
        ),

    /** Вывод УКАЗАННОЙ суммы токенов (не всего баланса) */
    withdraw: (amount: number) =>
        axiosInstance<{ sent: number; fee: number }>(
            instance.post(`/${ACCOUNT}/withdraw`, { amount })
        ),
}

export const BinanceNativeService = {
    /** Получить историю сделок */
    getDealHistory: (data: BinanceDealHistoryRequestModel) =>
        axiosInstance<BinanceDealHistoryResponseModel[]>(
            instance.post(`/${BINANCE_NATIVE}/trade-history`, data)
        ),

    /** Условия кредитного плеча для тикеров */
    getLeverage: (data: BinanceSymbolModel) =>
        axiosInstance<BinanceLeverageBracketResponseModel[]>(
            instance.post(`/${BINANCE_NATIVE}/leverage-bracket`, data)
        ),

    /** Изменить кредитное плечо */
    setLeverage: (data: BinanceSymbolModel) =>
        axiosInstance<BinanceLeverageResponseModel>(
            instance.post(`/${BINANCE_NATIVE}/leverage`, data)
        ),

    /** Новый ордер */
    setOrder: (data: BinanceSetOrderRequestModel) =>
        axiosInstance<BinanceSetOrderResponseModel>(
            instance.post(`/${BINANCE_NATIVE}/set-order`, data)
        ),

    /** Отменить ордер */
    cancelOrder: (data: BinanceCancelOrderRequestModel) =>
        axiosInstance<BinanceCancelOrderResponseModel>(
            instance.post(`/${BINANCE_NATIVE}/cancel-order`, data)
        ),

    /** Отменить все ордера */
    cancelAllOrders: (data: BinanceSymbolModel) =>
        axiosInstance<BinanceMessageResponseModel>(
            instance.post(`/${BINANCE_NATIVE}/cancel-all-orders`, data)
        ),

    /** Информация о символах для селекта */
    getSymbolsForSelect: () =>
        axiosInstance<BinanceGetSymbolsForSelectResponseModel[]>(
            instance.get(`/${BINANCE_NATIVE}/get-symbols-for-select`)
        ),
}

export const BinanceService = {
    /** Добавить ключи */
    create: (data: BinanceCreateModel) =>
        axiosInstance(instance.post(`/${BINANCE}`, data)),

    /** Получить ключи */
    get: (id: number) =>
        axiosInstance<BinanceDataModel>(instance.get(`/${BINANCE}/${id}`)),

    /** Изменить ключи */
    update: (id: number, data: BinanceUpdateModel) =>
        axiosInstance(instance.put(`/${BINANCE}/${id}`, data)),

    /** Удалить ключи */
    delete: (id: number) => axiosInstance(instance.delete(`/${BINANCE}/${id}`)),

    /** Включение робота */
    start: (id: number, data: MarketDataStartRequestModel) =>
        axiosInstance(instance.post(`/${BINANCE}/robot/start/${id}`, data)),

    /** Выключение робота */
    stop: (id: number) =>
        axiosInstance(instance.delete(`/${BINANCE}/robot/stop/${id}`)),

    /** Выключение всех роботов */
    stopAll: () => axiosInstance(instance.delete(`/${BINANCE}/robot/stop-all`)),

    /** Изменить статус сбора комиссии */
    setWithdrawStatus: (id: number, data: WithdrawStatusRequestModel) =>
        axiosInstance(instance.post(`/${BINANCE}/withdraw-status/${id}`, data)),

    /** Данные калькулятора робота (опрашивается каждые несколько секунд —
     *  без axiosInstance, чтобы сбой сети не сыпал уведомлениями). */
    getCalculator: (symbolId: number) =>
        instance
            .get<CryptoCalculatorDataModel>(
                `/${BINANCE}/calculator/${symbolId}`
            )
            .then(res => res.data),

    /** Сохранить лот и тейк клиента (без axiosInstance — ошибку покажет калькулятор). */
    saveClientSettings: (id: number, data: ClientSettingsModel) =>
        instance
            .put<ClientSettingsResultModel>(
                `/${BINANCE}/${id}/client-settings`,
                data
            )
            .then(res => res.data),
}

export const BinanceDealsService = {
    /** Получить сделки робота на бирже */
    search: (data: DealsRequestModel, skip?: number, limit?: number) =>
        axiosInstance<BaseSearchResponseModel<DealsResponseModel>>(
            instance.post(`/${BINANCE_DEALS}/${skip}/${limit}`, data)
        ),

    /** Статистика */
    getStatistic: (data: StatisticRequestModel = {}) =>
        axiosInstance<StatisticResponseModel>(
            instance.post(`/${BINANCE_DEALS}/statistic`, data)
        ),

    /** Статистика за выбранный период */
    getPeriodStatistic: (data: DealsRequestModel) =>
        axiosInstance<PeriodStatisticResponseModel>(
            instance.post(`/${BINANCE_DEALS}/period-statistic`, data)
        ),

    /** Данные о последний 10 сделках */
    getLiveTrading: () =>
        axiosInstance<LiveTradingResponseModel[]>(
            instance.post(`/${BINANCE_DEALS}/live-trading`)
        ),
}

export const BinanceSymbolsService = {
    /** Получить список символов */
    search: (skip?: number, limit?: number) =>
        axiosInstance<BaseSearchResponseModel<BinanceSymbolsResponseModel>>(
            instance.post(`/${BINANCE_SYMBOLS}/${skip}/${limit}`)
        ),

    /** Добавить символ */
    create: (data: BinanceSymbolsCreateRequestModel) =>
        axiosInstance(instance.post(`/${BINANCE_SYMBOLS}`, data)),

    /** Изменить символ */
    update: (data: BinanceSymbolsUpdateRequestModel) =>
        axiosInstance<BinanceSymbolsUpdateResponseModel[]>(
            instance.put(`/${BINANCE_SYMBOLS}`, data)
        ),

    /** Удалить символ */
    delete: (data: BinanceSymbolsDeleteRequestModel) =>
        axiosInstance<BinanceSymbolsUpdateResponseModel[]>(
            instance.post(`/${BINANCE_SYMBOLS}/delete`, data)
        ),

    /** Список символов для селекта */
    forSelect: () =>
        axiosInstance<BinanceSymbolsForSelectResponseModel[]>(
            instance.post(`/${BINANCE_SYMBOLS}/for-select`)
        ),

    /** Минимальный баланс токенов */
    getMinTokenBalance: (data: BinanceSymbolsGetMinTokenBalanceRequestModel) =>
        axiosInstance<number>(
            instance.post(`/${BINANCE_SYMBOLS}/min-token-balance`, data)
        ),

    /** Получить параметры для робота */
    getParams: () =>
        axiosInstance<ChangeRobotParamsModel>(
            instance.get(`/${BINANCE_SYMBOLS}/get-params`)
        ),

    /** Изменить параметры для робота */
    changeParams: (data: ChangeRobotParamsModel) =>
        axiosInstance(instance.post(`/${BINANCE_SYMBOLS}/change-params`, data)),
}

export const RithmicService = {
    /** Получить данные маркета */
    getByAccount: (id: number) =>
        axiosInstance<RithmicDataModel>(
            instance.get(`/${RITHMIC}/by-account/${id}`)
        ),

    /** Добавить ключи */
    create: (data: RithmicCreateModel) =>
        axiosInstance(instance.post(`/${RITHMIC}`, data)),

    /** Изменить запись */
    update: (id: number, data: RithmicUpdateDto) =>
        axiosInstance(instance.put(`/${RITHMIC}/${id}`, data)),

    /** Удалить ключи */
    delete: (id: number) => axiosInstance(instance.delete(`/${RITHMIC}/${id}`)),

    /** Получить аккаунты*/
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<RithmicDataSearchDto>>(
            instance.post(`/${RITHMIC}/search/${skip}/${limit}`, {})
        ),

    /** Включение робота */
    start: (id: number, data: RithmicStartDto) =>
        axiosInstance(instance.post(`/${RITHMIC}/robot/start/${id}`, data)),

    /** Выключение робота */
    stop: (id: number) =>
        axiosInstance(instance.delete(`/${RITHMIC}/robot/stop/${id}`)),

    /** Данные калькулятора робота (опрашивается каждые несколько секунд —
     *  без axiosInstance, чтобы сбой сети не сыпал уведомлениями). */
    getCalculator: (symbolId: number) =>
        instance
            .get<FuturesCalculatorDataModel>(
                `/${RITHMIC}/calculator/${symbolId}`
            )
            .then(res => res.data),

    /** Сохранить лот и тейк клиента (без axiosInstance — ошибку покажет калькулятор). */
    saveClientSettings: (id: number, data: ClientSettingsModel) =>
        instance
            .put<ClientSettingsResultModel>(
                `/${RITHMIC}/${id}/client-settings`,
                data
            )
            .then(res => res.data),
}

export const RithmicDealsService = {
    /** Get robot deals */
    search: (skip: number, limit: number, data: DealsSearchDto) =>
        axiosInstance<BaseSearchResponseModel<DealDto>>(
            instance.post(`/${RITHMIC_DEALS}/search/${skip}/${limit}`, data)
        ),

    /** Statistics */
    getStatisticSummary: (accountId: number) =>
        axiosInstance<DealsStatisticSummaryDto>(
            instance.get(`/${RITHMIC_DEALS}/summary/${accountId}`)
        ),

    /** Statistics for the selected period (profit + commission RCC/USDT) */
    getPeriodStatistic: (accountId: number, data: DealsPeriodStatisticDto) =>
        axiosInstance<DealsPeriodStatisticResultDto>(
            instance.post(`/${RITHMIC_DEALS}/period/${accountId}`, data)
        ),
}

export const RithmicSymbolsService = {
    /** Добавить символ */
    create: (data: RithmicSymbolBaseDto) =>
        axiosInstance(instance.post(`/${RITHMIC_SYMBOLS}`, data)),

    /** Изменить символ */
    update: (id: number, data: RithmicSymbolBaseDto) =>
        axiosInstance(instance.put(`/${RITHMIC_SYMBOLS}/${id}`, data)),

    /** Удалить символ */
    delete: (id: number) =>
        axiosInstance(instance.delete(`/${RITHMIC_SYMBOLS}/${id}`)),

    /** Получить список символов */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<RithmicSymbolDto>>(
            instance.post(`/${RITHMIC_SYMBOLS}/${skip}/${limit}`)
        ),

    /** Получить список символов для селекта */
    getForSelect: () =>
        axiosInstance<RithmicSymbolForSelectDto[]>(
            instance.get(`/${RITHMIC_SYMBOLS}/for-select`)
        ),

    /** Получить биржевых символов */
    getSymbols: () =>
        axiosInstance<RithmicNativeSymbolDto>(
            instance.get(`/${RITHMIC_SYMBOLS}/symbols`)
        ),

    /** Живые контракты (месяцы) под корневым символом — текущий + следующие */
    getContractMonths: (root: string) =>
        axiosInstance<RithmicContractMonthDto[]>(
            instance.get(`/${RITHMIC_SYMBOLS}/contract-months/${root}`)
        ),
}

export const BybitService = {
    /** Получить данные маркета */
    getByAccount: (id: number) =>
        axiosInstance<BybitDataModel>(
            instance.get(`/${BYBIT}/by-account/${id}`)
        ),

    /** Добавить ключи */
    create: (data: BybitCreateDto) =>
        axiosInstance(instance.post(`/${BYBIT}`, data)),

    /** Изменить ключи */
    update: (id: number, data: BybitUpdateDto) =>
        axiosInstance(instance.put(`/${BYBIT}/${id}`, data)),

    /** Удалить ключи */
    delete: (id: number) => axiosInstance(instance.delete(`/${BYBIT}/${id}`)),

    /** Получить аккаунты с фильтром*/
    search: (skip: number, limit: number, data: BybitSearchDto) =>
        axiosInstance<BaseSearchResponseModel<BybitDataSearchDto>>(
            instance.post(`/${BYBIT}/search/${skip}/${limit}`, data)
        ),

    /** Включение робота */
    start: (id: number, data: BybitStartDto) =>
        axiosInstance(instance.post(`/${BYBIT}/robot/start/${id}`, data)),

    /** Выключение робота */
    stop: (id: number) =>
        axiosInstance(instance.delete(`/${BYBIT}/robot/stop/${id}`)),

    /** Остановка роботов в любом статусе */
    hardStopAll: (data?: BybitHardStopAllDto) =>
        axiosInstance(instance.post(`/${BYBIT}/robot/hard-stop-all`, data)),

    /** Данные калькулятора робота.  Без axiosInstance: страница опрашивает цену
     *  каждые несколько секунд, и сбой сети не должен сыпать уведомлениями. */
    getCalculator: (symbolId: number) =>
        instance
            .get<CryptoCalculatorDataModel>(`/${BYBIT}/calculator/${symbolId}`)
            .then(res => res.data),

    /** Сохранить лот и тейк клиента (без axiosInstance — ошибку покажет калькулятор). */
    saveClientSettings: (id: number, data: ClientSettingsModel) =>
        instance
            .put<ClientSettingsResultModel>(
                `/${BYBIT}/${id}/client-settings`,
                data
            )
            .then(res => res.data),
}

export const BybitNativeService = {
    /** Получить баланс */
    balance: (id: number) =>
        axiosInstance<BybitBalanceDto>(
            instance.get(`/${BYBIT_NATIVE}/balance/${id}`)
        ),

    /** Получить лимиты риска */
    riskLimit: (symbol: string) =>
        axiosInstance<BybitRiskLimitsDto>(
            instance.get(`/${BYBIT_NATIVE}/risk-limit/${symbol}`)
        ),

    /** Разместить ордер */
    sendOrder: (id: number, data: BybitSendOrderDto) =>
        axiosInstance<BybitOrderIdDto>(
            instance.post(`/${BYBIT_NATIVE}/send-order/${id}`, data)
        ),

    /** Отменить ордер */
    cancelOrder: (id: number, data: BybitCancelOrderDto) =>
        axiosInstance(
            instance.post(`/${BYBIT_NATIVE}/cancel-order/${id}`, data)
        ),

    /** Отменить все ордера */
    cancelAllOrders: (id: number) =>
        axiosInstance(instance.get(`/${BYBIT_NATIVE}/cancel-all-orders/${id}`)),

    /** Изменить кредитное плечо */
    changeLeverage: (id: number, data: BybitChangeLeverageDto) =>
        axiosInstance(
            instance.post(`/${BYBIT_NATIVE}/change-leverage/${id}`, data)
        ),

    /** Get position info */
    getPositionInfo: (id: number, data: BybitGetPositionDto) =>
        axiosInstance<BybitPositionDto[]>(
            instance.post(`/${BYBIT_NATIVE}/get-position-info/${id}`, data)
        ),

    /** Получить историю ордеров */
    getOrdersHistory: (id: number, data: BybitGetOrdersHistoryDto) =>
        axiosInstance<BybitOrderHistoryDto[]>(
            instance.post(`/${BYBIT_NATIVE}/get-orders-history/${id}`, data)
        ),

    /** Получить историю позиций */
    getPositionsHistory: (id: number, data: BybitGetPositionsHistoryDto) =>
        axiosInstance<BybitPositionHistoryDto[]>(
            instance.post(`/${BYBIT_NATIVE}/get-positions-history/${id}`, data)
        ),

    /** Получить информацию о символах */
    getInstrumentsInfo: () =>
        axiosInstance<BybitGetInstrumentInfoDto[]>(
            instance.post(`/${BYBIT_NATIVE}/get-instruments-info`)
        ),

    /** Switch position mode */
    switchPositionMode: (id: number, data: BybitSwitchPositionModeDto) =>
        axiosInstance(
            instance.post(`/${BYBIT_NATIVE}/switch-position-mode/${id}`, data)
        ),

    /** Минимальный баланс токенов */
    getMinTokenBalance: (data: MinTokenBalanceDto) =>
        axiosInstance<number>(
            instance.post(`/${BYBIT_NATIVE}/min-token-balance`, data)
        ),
}

export const BybitSymbolsService = {
    /** Добавить символ */
    create: (data: BybitSymbolBaseDto) =>
        axiosInstance(instance.post(`/${BYBIT_SYMBOLS}`, data)),

    /** Изменить символ */
    update: (id: number, data: BybitSymbolBaseDto) =>
        axiosInstance(instance.put(`/${BYBIT_SYMBOLS}/${id}`, data)),

    /** Удалить символ */
    delete: (id: number) =>
        axiosInstance(instance.delete(`/${BYBIT_SYMBOLS}/${id}`)),

    /** Получить список символов */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<BybitSymbolDto>>(
            instance.post(`/${BYBIT_SYMBOLS}/${skip}/${limit}`)
        ),

    /** Получить список символов для селекта */
    getForSelect: () =>
        axiosInstance<BybitSymbolForSelectDto[]>(
            instance.get(`/${BYBIT_SYMBOLS}/for-select`)
        ),
}

export const BybitDealsService = {
    /** Получить список сделок */
    search: (skip: number, limit: number, data: DealsSearchDto) =>
        axiosInstance<BaseSearchResponseModel<DealDto>>(
            instance.post(`/${BYBIT_DEALS}/search/${skip}/${limit}`, data)
        ),

    /** Статистика */
    getStatisticSummary: (accountId: number) =>
        axiosInstance<DealsStatisticSummaryDto>(
            instance.get(`/${BYBIT_DEALS}/summary/${accountId}`)
        ),

    /** Статистика за выбранный период (profit + commission RCC/USDT) */
    getPeriodStatistic: (accountId: number, data: DealsPeriodStatisticDto) =>
        axiosInstance<DealsPeriodStatisticResultDto>(
            instance.post(`/${BYBIT_DEALS}/period/${accountId}`, data)
        ),

    /** Live-trading: сделки случайного Bybit-аккаунта (для главной) */
    getLiveTrading: () =>
        axiosInstance<LiveTradingResponseModel[]>(
            instance.post(`/${BYBIT_DEALS}/live-trading`)
        ),
}

export const BitgetService = {
    /** Получить данные маркета */
    getByAccount: (id: number) =>
        axiosInstance<BitgetDataModel>(
            instance.get(`/${BITGET}/by-account/${id}`)
        ),

    /** Добавить ключи */
    create: (data: BitgetCreateDto) =>
        axiosInstance(instance.post(`/${BITGET}`, data)),

    /** Изменить ключи */
    update: (id: number, data: BitgetUpdateDto) =>
        axiosInstance(instance.put(`/${BITGET}/${id}`, data)),

    /** Удалить ключи */
    delete: (id: number) => axiosInstance(instance.delete(`/${BITGET}/${id}`)),

    /** Получить аккаунты с фильтром*/
    search: (skip: number, limit: number, data: BitgetSearchDto) =>
        axiosInstance<BaseSearchResponseModel<BitgetDataSearchDto>>(
            instance.post(`/${BITGET}/search/${skip}/${limit}`, data)
        ),

    /** Включение робота */
    start: (id: number, data: BitgetStartDto) =>
        axiosInstance(instance.post(`/${BITGET}/robot/start/${id}`, data)),

    /** Выключение робота */
    stop: (id: number) =>
        axiosInstance(instance.delete(`/${BITGET}/robot/stop/${id}`)),

    /** Остановка роботов в любом статусе */
    hardStopAll: (data?: BitgetHardStopAllDto) =>
        axiosInstance(instance.post(`/${BITGET}/robot/hard-stop-all`, data)),

    /** Данные калькулятора робота (опрашивается каждые несколько секунд —
     *  без axiosInstance, чтобы сбой сети не сыпал уведомлениями). */
    getCalculator: (symbolId: number) =>
        instance
            .get<CryptoCalculatorDataModel>(`/${BITGET}/calculator/${symbolId}`)
            .then(res => res.data),

    /** Сохранить лот и тейк клиента (без axiosInstance — ошибку покажет калькулятор). */
    saveClientSettings: (id: number, data: ClientSettingsModel) =>
        instance
            .put<ClientSettingsResultModel>(
                `/${BITGET}/${id}/client-settings`,
                data
            )
            .then(res => res.data),
}

export const BitgetNativeService = {
    /** Получить баланс */
    balance: (id: number) =>
        axiosInstance<BitgetBalanceDto>(
            instance.get(`/${BITGET_NATIVE}/balance/${id}`)
        ),

    /** Получить лимиты риска */
    riskLimit: (symbol: string) =>
        axiosInstance<BitgetRiskLimitsDto>(
            instance.get(`/${BITGET_NATIVE}/risk-limit/${symbol}`)
        ),

    /** Разместить ордер */
    sendOrder: (id: number, data: BitgetSendOrderDto) =>
        axiosInstance<BitgetOrderIdDto>(
            instance.post(`/${BITGET_NATIVE}/send-order/${id}`, data)
        ),

    /** Отменить ордер */
    cancelOrder: (id: number, data: BitgetCancelOrderDto) =>
        axiosInstance(
            instance.post(`/${BITGET_NATIVE}/cancel-order/${id}`, data)
        ),

    /** Отменить все ордера */
    cancelAllOrders: (id: number) =>
        axiosInstance(
            instance.get(`/${BITGET_NATIVE}/cancel-all-orders/${id}`)
        ),

    /** Изменить кредитное плечо */
    changeLeverage: (id: number, data: BitgetChangeLeverageDto) =>
        axiosInstance(
            instance.post(`/${BITGET_NATIVE}/change-leverage/${id}`, data)
        ),

    /** Get position info */
    getPositionInfo: (id: number, data: BitgetGetPositionDto) =>
        axiosInstance<BitgetPositionDto[]>(
            instance.post(`/${BITGET_NATIVE}/get-position-info/${id}`, data)
        ),

    /** Получить историю ордеров */
    getOrdersHistory: (id: number, data: BitgetGetOrdersHistoryDto) =>
        axiosInstance<BitgetOrderHistoryDto[]>(
            instance.post(`/${BITGET_NATIVE}/get-orders-history/${id}`, data)
        ),

    /** Получить историю позиций */
    getPositionsHistory: (id: number, data: BitgetGetPositionsHistoryDto) =>
        axiosInstance<BitgetPositionHistoryDto[]>(
            instance.post(`/${BITGET_NATIVE}/get-positions-history/${id}`, data)
        ),

    /** Получить информацию о символах */
    getInstrumentsInfo: () =>
        axiosInstance<BitgetGetInstrumentInfoDto[]>(
            instance.post(`/${BITGET_NATIVE}/get-instruments-info`)
        ),

    /** Switch position mode */
    switchPositionMode: (id: number, data: BitgetSwitchPositionModeDto) =>
        axiosInstance(
            instance.post(`/${BITGET_NATIVE}/switch-position-mode/${id}`, data)
        ),

    /** Минимальный баланс токенов */
    getMinTokenBalance: (data: MinTokenBalanceDto) =>
        axiosInstance<number>(
            instance.post(`/${BITGET_NATIVE}/min-token-balance`, data)
        ),
}

export const BitgetSymbolsService = {
    /** Добавить символ */
    create: (data: BitgetSymbolBaseDto) =>
        axiosInstance(instance.post(`/${BITGET_SYMBOLS}`, data)),

    /** Изменить символ */
    update: (id: number, data: BitgetSymbolBaseDto) =>
        axiosInstance(instance.put(`/${BITGET_SYMBOLS}/${id}`, data)),

    /** Удалить символ */
    delete: (id: number) =>
        axiosInstance(instance.delete(`/${BITGET_SYMBOLS}/${id}`)),

    /** Получить список символов */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<BitgetSymbolDto>>(
            instance.post(`/${BITGET_SYMBOLS}/${skip}/${limit}`)
        ),

    /** Получить список символов для селекта */
    getForSelect: () =>
        axiosInstance<BitgetSymbolForSelectDto[]>(
            instance.get(`/${BITGET_SYMBOLS}/for-select`)
        ),
}

export const BitgetDealsService = {
    /** Получить список сделок */
    search: (skip: number, limit: number, data: DealsSearchDto) =>
        axiosInstance<BaseSearchResponseModel<DealDto>>(
            instance.post(`/${BITGET_DEALS}/search/${skip}/${limit}`, data)
        ),

    /** Статистика */
    getStatisticSummary: (accountId: number) =>
        axiosInstance<DealsStatisticSummaryDto>(
            instance.get(`/${BITGET_DEALS}/summary/${accountId}`)
        ),

    /** Статистика за выбранный период (profit + commission RCC/USDT) */
    getPeriodStatistic: (accountId: number, data: DealsPeriodStatisticDto) =>
        axiosInstance<DealsPeriodStatisticResultDto>(
            instance.post(`/${BITGET_DEALS}/period/${accountId}`, data)
        ),

    /** Live-trading: сделки случайного Bitget-аккаунта (для главной) */
    getLiveTrading: () =>
        axiosInstance<LiveTradingResponseModel[]>(
            instance.post(`/${BITGET_DEALS}/live-trading`)
        ),
}

// ─────────────────────────────────────────────────────────────────────
// OKX — зеркало Bybit-сервисов, с тремя отличиями:
//   1. OkxCreateDto/UpdateDto принимают `passphrase` (третий секрет);
//   2. `switchPositionMode` принимает posMode на уровне аккаунта (не per-symbol);
//   3. Маршрутизация баланса/cancel-all/etc. идёт на /okx-native эндпоинты.
// ─────────────────────────────────────────────────────────────────────

export const OkxService = {
    getByAccount: (id: number) =>
        axiosInstance<OkxDataModel>(instance.get(`/${OKX}/by-account/${id}`)),

    create: (data: OkxCreateDto) =>
        axiosInstance(instance.post(`/${OKX}`, data)),

    update: (id: number, data: OkxUpdateDto) =>
        axiosInstance(instance.put(`/${OKX}/${id}`, data)),

    delete: (id: number) => axiosInstance(instance.delete(`/${OKX}/${id}`)),

    search: (skip: number, limit: number, data: OkxSearchDto) =>
        axiosInstance<BaseSearchResponseModel<OkxDataSearchDto>>(
            instance.post(`/${OKX}/search/${skip}/${limit}`, data)
        ),

    start: (id: number, data: OkxStartDto) =>
        axiosInstance(instance.post(`/${OKX}/robot/start/${id}`, data)),

    stop: (id: number) =>
        axiosInstance(instance.delete(`/${OKX}/robot/stop/${id}`)),

    hardStopAll: (data?: OkxHardStopAllDto) =>
        axiosInstance(instance.post(`/${OKX}/robot/hard-stop-all`, data)),

    /** Данные калькулятора робота (опрашивается каждые несколько секунд —
     *  без axiosInstance, чтобы сбой сети не сыпал уведомлениями). */
    getCalculator: (symbolId: number) =>
        instance
            .get<CryptoCalculatorDataModel>(`/${OKX}/calculator/${symbolId}`)
            .then(res => res.data),

    /** Сохранить лот и тейк клиента (без axiosInstance — ошибку покажет калькулятор). */
    saveClientSettings: (id: number, data: ClientSettingsModel) =>
        instance
            .put<ClientSettingsResultModel>(
                `/${OKX}/${id}/client-settings`,
                data
            )
            .then(res => res.data),
}

export const OkxNativeService = {
    getBalance: (id: number) =>
        axiosInstance<OkxBalanceDto>(
            instance.get(`/${OKX_NATIVE}/balance/${id}`)
        ),

    getRiskLimit: (symbol: string) =>
        axiosInstance<OkxRiskLimitsDto>(
            instance.get(`/${OKX_NATIVE}/risk-limit/${symbol}`)
        ),

    sendOrder: (id: number, data: OkxSendOrderDto) =>
        axiosInstance<OkxOrderIdDto>(
            instance.post(`/${OKX_NATIVE}/send-order/${id}`, data)
        ),

    cancelOrder: (id: number, data: OkxCancelOrderDto) =>
        axiosInstance(instance.post(`/${OKX_NATIVE}/cancel-order/${id}`, data)),

    cancelAllOrders: (id: number) =>
        axiosInstance(instance.get(`/${OKX_NATIVE}/cancel-all-orders/${id}`)),

    changeLeverage: (id: number, data: OkxChangeLeverageDto) =>
        axiosInstance(
            instance.post(`/${OKX_NATIVE}/change-leverage/${id}`, data)
        ),

    getPositionInfo: (id: number, data: OkxGetPositionDto) =>
        axiosInstance<OkxPositionDto[]>(
            instance.post(`/${OKX_NATIVE}/get-position-info/${id}`, data)
        ),

    getOrdersHistory: (id: number, data: OkxGetOrdersHistoryDto) =>
        axiosInstance<OkxOrderHistoryDto[]>(
            instance.post(`/${OKX_NATIVE}/get-orders-history/${id}`, data)
        ),

    getPositionsHistory: (id: number, data: OkxGetPositionsHistoryDto) =>
        axiosInstance<OkxPositionHistoryDto[]>(
            instance.post(`/${OKX_NATIVE}/get-positions-history/${id}`, data)
        ),

    getInstrumentsInfo: () =>
        axiosInstance<OkxGetInstrumentInfoDto[]>(
            instance.post(`/${OKX_NATIVE}/get-instruments-info`)
        ),

    /**
     * OKX переключает posMode на уровне аккаунта (`posMode` — long_short_mode
     * либо net_mode), не per-symbol как у Bybit.  Сервер принимает DTO с
     * полем posMode.
     */
    switchPositionMode: (id: number, data: OkxSwitchPositionModeDto) =>
        axiosInstance(
            instance.post(`/${OKX_NATIVE}/switch-position-mode/${id}`, data)
        ),

    getMinTokenBalance: (data: { marketId: number; symbolId: number }) =>
        axiosInstance<number>(
            instance.post(`/${OKX_NATIVE}/min-token-balance`, data)
        ),
}

export const OkxSymbolsService = {
    create: (data: OkxSymbolBaseDto) =>
        axiosInstance(instance.post(`/${OKX_SYMBOLS}`, data)),

    update: (id: number, data: OkxSymbolBaseDto) =>
        axiosInstance(instance.put(`/${OKX_SYMBOLS}/${id}`, data)),

    delete: (id: number) =>
        axiosInstance(instance.delete(`/${OKX_SYMBOLS}/${id}`)),

    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<OkxSymbolDto>>(
            instance.post(`/${OKX_SYMBOLS}/${skip}/${limit}`)
        ),

    getForSelect: () =>
        axiosInstance<OkxSymbolForSelectDto[]>(
            instance.get(`/${OKX_SYMBOLS}/for-select`)
        ),
}

export const OkxDealsService = {
    search: (skip: number, limit: number, data: DealsSearchDto) =>
        axiosInstance<BaseSearchResponseModel<DealDto>>(
            instance.post(`/${OKX_DEALS}/search/${skip}/${limit}`, data)
        ),

    getStatisticSummary: (accountId: number) =>
        axiosInstance<DealsStatisticSummaryDto>(
            instance.get(`/${OKX_DEALS}/summary/${accountId}`)
        ),

    getPeriodStatistic: (accountId: number, data: DealsPeriodStatisticDto) =>
        axiosInstance<DealsPeriodStatisticResultDto>(
            instance.post(`/${OKX_DEALS}/period/${accountId}`, data)
        ),

    /** Данные о последних сделках для блока Live trading на главной */
    getLiveTrading: () =>
        axiosInstance<LiveTradingResponseModel[]>(
            instance.post(`/${OKX_DEALS}/live-trading`)
        ),
}

// ─────────────────────────────────────────────────────────────────────
// Staking + Referral (off-chain зеркало RealColibri-контрактов)
// ─────────────────────────────────────────────────────────────────────

export const StakingService = {
    /** Заблокировать RCC в стейк (с omoложением при доливке) */
    lock: (data: StakeLockDto) =>
        axiosInstance(instance.post(`/${STAKING}/lock`, data)),

    /** Full unstake + auto-claim всех pending */
    unlock: () =>
        axiosInstance<UnstakeResultDto>(instance.post(`/${STAKING}/unlock`)),

    /** Забрать pending staking-выплаты (cascade-pool) */
    claim: () =>
        axiosInstance<ClaimResultDto>(instance.post(`/${STAKING}/claim`)),

    /** Текущее состояние моего стейка */
    getMyState: () =>
        axiosInstance<StakingStateDto>(instance.get(`/${STAKING}/my`)),

    /** Статистика пула + моя ожидаемая доля */
    getPoolStats: () =>
        axiosInstance<StakingPoolStatsDto>(
            instance.get(`/${STAKING}/pool-stats`)
        ),

    /** Админ: распределить пул сейчас (вручную, не дожидаясь cron'а) */
    adminDistribute: () =>
        axiosInstance<{ pool: number; stakers: number; distributed: number }>(
            instance.post(`/${STAKING}/admin/distribute`)
        ),
}

export const ReferralService = {
    /** Прямые рефералы текущего user'а с краткой статистикой */
    getClients: () =>
        axiosInstance<ReferralClientDto[]>(
            instance.get(`/${REFERRAL}/clients`)
        ),

    /** Сводная статистика партнёра (direct/tree count, pending/claimed) */
    getStats: () =>
        axiosInstance<ReferralStatsDto>(instance.get(`/${REFERRAL}/stats`)),

    /** Забрать pending referral-выплаты на deposit */
    claim: () =>
        axiosInstance<ClaimResultDto>(instance.post(`/${REFERRAL}/claim`)),

    /** История referral-выплат с пагинацией */
    getPayouts: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<ReferralPayoutDto>>(
            instance.post(`/${REFERRAL}/payouts/${skip}/${limit}`)
        ),

    /** Мой прогресс к статусу партнёра */
    getEligibility: () =>
        axiosInstance<EligibilityDto>(instance.get(`/${REFERRAL}/eligibility`)),

    /** Подать заявку на партнёрство (eligibility должна быть достигнута) */
    requestPartner: () =>
        axiosInstance<EligibilityDto>(
            instance.post(`/${REFERRAL}/request-partner`)
        ),

    /** [admin] Список pending заявок */
    adminGetPartnerRequests: () =>
        axiosInstance<PartnerRequestDto[]>(
            instance.get(`/${REFERRAL}/admin/partner-requests`)
        ),

    /** [admin] Список активных (одобренных) партнёров */
    adminGetActivePartners: () =>
        axiosInstance<ActivePartnerDto[]>(
            instance.get(`/${REFERRAL}/admin/active-partners`)
        ),

    /** [admin] Одобрить заявку */
    adminApprovePartner: (userId: number) =>
        axiosInstance(
            instance.post(`/${REFERRAL}/admin/approve-partner/${userId}`)
        ),

    /** [admin] Отозвать статус партнёра */
    adminRevokePartner: (userId: number) =>
        axiosInstance(
            instance.post(`/${REFERRAL}/admin/revoke-partner/${userId}`)
        ),

    // ── Stage 21b — Partner-bonus (VIP) ────────────────────────────────

    /** VIP-бонус статистика партнёра */
    getPartnerBonusStats: () =>
        axiosInstance<PartnerBonusStatsDto>(
            instance.get(`/${REFERRAL}/partner/bonus-stats`)
        ),

    /** Забрать pending VIP-бонус на deposit */
    claimPartnerBonus: () =>
        axiosInstance<ClaimResultDto>(
            instance.post(`/${REFERRAL}/partner/claim-bonus`)
        ),

    /** История partner-bonus выплат */
    getPartnerPayouts: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<PartnerPayoutDto>>(
            instance.post(`/${REFERRAL}/partner/payouts/${skip}/${limit}`)
        ),
}

export const PartnerService = {
    /** Мои клиенты (прямые рефералы) + статус робота по биржам */
    getClients: () =>
        axiosInstance<PartnerClientModel[]>(
            instance.get(`/${PARTNER}/clients`)
        ),

    /** Проверить доступ партнёра к конкретному клиенту (для guard) */
    checkClient: (accountId: number) =>
        axiosInstance<{ ok: boolean }>(
            instance.get(`/${PARTNER}/clients/${accountId}/check`)
        ),

    /** Read-only снимок торговли клиента на бирже */
    getClientTrade: (accountId: number, exchange: string) =>
        axiosInstance<PartnerClientTradeModel>(
            instance.get(`/${PARTNER}/clients/${accountId}/trade/${exchange}`)
        ),
}

export const PushService = {
    /** VAPID public key (нужен для pushManager.subscribe) */
    getPublicKey: () =>
        axiosInstance<PushPublicKeyDto>(instance.get(`/${PUSH}/public-key`)),

    /** Сохранить подписку (после pushManager.subscribe в SW) */
    subscribe: (data: PushSubscribeDto) =>
        axiosInstance<PushSubscribeResultDto>(
            instance.post(`/${PUSH}/subscribe`, data)
        ),

    /** Удалить подписку по endpoint */
    unsubscribe: (data: PushUnsubscribeDto) =>
        axiosInstance(instance.post(`/${PUSH}/unsubscribe`, data)),

    /** Тестовое уведомление текущему юзеру (debug) */
    sendTest: (data?: { title?: string; body?: string }) =>
        axiosInstance(instance.post(`/${PUSH}/test`, data || {})),
}

export const ArchitectureService = {
    /** Admin-only: детальная схема архитектуры ядра (не в публичном бандле) */
    getDiagram: () =>
        axiosInstance<ArchitectureDiagram>(
            instance.get(`/${ARCHITECTURE}/diagram`)
        ),
}

export const BookService = {
    /** Admin-only: очищенный книжный нарратив (без механики алгоритма) */
    getDraft: (lang: string) =>
        axiosInstance<BookDraft>(
            instance.get(`/${BOOK}/draft`, { params: { lang } })
        ),
}

export const TTService = {
    /** Получить данные TT по аккаунту */
    getByAccount: (id: number) =>
        axiosInstance<TTDataModel>(instance.get(`/${TT}/by-account/${id}`)),

    /** Добавить TT ключи */
    create: (data: TTCreateModel) =>
        axiosInstance(instance.post(`/${TT}`, data)),

    /** Изменить TT запись */
    update: (id: number, data: TTUpdateDto) =>
        axiosInstance(instance.put(`/${TT}/${id}`, data)),

    /** Удалить TT ключи */
    delete: (id: number) => axiosInstance(instance.delete(`/${TT}/${id}`)),

    /** Получить TT аккаунты (admin) */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<TTDataSearchDto>>(
            instance.post(`/${TT}/search/${skip}/${limit}`)
        ),

    /** Запустить TT робота */
    start: (id: number, data: TTStartDto) =>
        axiosInstance(instance.post(`/${TT}/robot/start/${id}`, data)),

    /** Остановить TT робота */
    stop: (id: number) =>
        axiosInstance(instance.delete(`/${TT}/robot/stop/${id}`)),
}

export const TTSymbolsService = {
    /** Добавить символ TT */
    create: (data: TTSymbolBaseDto) =>
        axiosInstance(instance.post(`/${TT_SYMBOLS}`, data)),

    /** Изменить символ TT */
    update: (id: number, data: TTSymbolBaseDto) =>
        axiosInstance(instance.put(`/${TT_SYMBOLS}/${id}`, data)),

    /** Удалить символ TT */
    delete: (id: number) =>
        axiosInstance(instance.delete(`/${TT_SYMBOLS}/${id}`)),

    /** Список символов TT */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<TTSymbolDto>>(
            instance.post(`/${TT_SYMBOLS}/${skip}/${limit}`)
        ),

    /** Список символов TT для селекта */
    getForSelect: () =>
        axiosInstance<TTSymbolForSelectDto[]>(
            instance.get(`/${TT_SYMBOLS}/for-select`)
        ),
}

export const TTDealsService = {
    /** Получить сделки TT */
    search: (skip: number, limit: number, data: DealsSearchDto) =>
        axiosInstance<BaseSearchResponseModel<DealDto>>(
            instance.post(`/${TT_DEALS}/search/${skip}/${limit}`, data)
        ),

    /** Статистика TT */
    getStatisticSummary: (accountId: number) =>
        axiosInstance<DealsStatisticSummaryDto>(
            instance.get(`/${TT_DEALS}/summary/${accountId}`)
        ),

    /** Статистика TT за период */
    getPeriodStatistic: (accountId: number, data: DealsPeriodStatisticDto) =>
        axiosInstance<DealsPeriodStatisticResultDto>(
            instance.post(`/${TT_DEALS}/period/${accountId}`, data)
        ),
}

export const CQGService = {
    /** Получить данные CQG по аккаунту */
    getByAccount: (id: number) =>
        axiosInstance<CQGDataModel>(instance.get(`/${CQG}/by-account/${id}`)),

    /** Добавить CQG credentials */
    create: (data: CQGCreateModel) =>
        axiosInstance(instance.post(`/${CQG}`, data)),

    /** Изменить CQG запись */
    update: (id: number, data: CQGUpdateDto) =>
        axiosInstance(instance.put(`/${CQG}/${id}`, data)),

    /** Удалить CQG credentials */
    delete: (id: number) => axiosInstance(instance.delete(`/${CQG}/${id}`)),

    /** Получить CQG аккаунты (admin) */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<CQGDataSearchDto>>(
            instance.post(`/${CQG}/search/${skip}/${limit}`)
        ),

    /** Запустить CQG робота */
    start: (id: number, data: CQGStartDto) =>
        axiosInstance(instance.post(`/${CQG}/robot/start/${id}`, data)),

    /** Остановить CQG робота */
    stop: (id: number) =>
        axiosInstance(instance.delete(`/${CQG}/robot/stop/${id}`)),
}

export const CQGSymbolsService = {
    /** Добавить символ CQG */
    create: (data: CQGSymbolBaseDto) =>
        axiosInstance(instance.post(`/${CQG_SYMBOLS}`, data)),

    /** Изменить символ CQG */
    update: (id: number, data: CQGSymbolBaseDto) =>
        axiosInstance(instance.put(`/${CQG_SYMBOLS}/${id}`, data)),

    /** Удалить символ CQG */
    delete: (id: number) =>
        axiosInstance(instance.delete(`/${CQG_SYMBOLS}/${id}`)),

    /** Список символов CQG */
    search: (skip: number, limit: number) =>
        axiosInstance<BaseSearchResponseModel<CQGSymbolDto>>(
            instance.post(`/${CQG_SYMBOLS}/${skip}/${limit}`)
        ),

    /** Список символов CQG для селекта */
    getForSelect: () =>
        axiosInstance<CQGSymbolForSelectDto[]>(
            instance.get(`/${CQG_SYMBOLS}/for-select`)
        ),
}

export const CQGDealsService = {
    /** Получить сделки CQG */
    search: (skip: number, limit: number, data: DealsSearchDto) =>
        axiosInstance<BaseSearchResponseModel<DealDto>>(
            instance.post(`/${CQG_DEALS}/search/${skip}/${limit}`, data)
        ),

    /** Статистика CQG */
    getStatisticSummary: (accountId: number) =>
        axiosInstance<DealsStatisticSummaryDto>(
            instance.get(`/${CQG_DEALS}/summary/${accountId}`)
        ),

    /** Статистика CQG за период */
    getPeriodStatistic: (accountId: number, data: DealsPeriodStatisticDto) =>
        axiosInstance<DealsPeriodStatisticResultDto>(
            instance.post(`/${CQG_DEALS}/period/${accountId}`, data)
        ),
}

/** Порядок отзывов: самые залайканные / новые / старые. */
export type CommentSort = 'likes' | 'new' | 'old'

export const CommentsService = {
    /** Лента отзывов (доступна и гостю).
     *  `lang` — язык сайта: бэкенд переведёт отзывы на него автоматически. */
    getList: (
        skip: number,
        limit: number,
        lang?: string,
        sort: CommentSort = 'likes'
    ) =>
        axiosInstance<BaseSearchResponseModel<CommentModel>>(
            instance.get(`/${COMMENTS}/${skip}/${limit}`, {
                params: { lang, sort },
            })
        ),

    /** Оставить отзыв (только для авторизованных) */
    create: (text: string) =>
        axiosInstance<CommentModel>(instance.post(`/${COMMENTS}`, { text })),

    /** Удалить отзыв (свой — автор, любой — админ) */
    remove: (id: number) =>
        axiosInstance(instance.delete(`/${COMMENTS}/${id}`)),

    /** Поставить/снять лайк. Свой отзыв лайкать нельзя. */
    toggleLike: (id: number) =>
        axiosInstance<{ likes: number; isLiked: boolean }>(
            instance.post(`/${COMMENTS}/${id}/like`)
        ),
}

/** Границы периода (ms). Пустые поля бэкенд трактует как «за всё время». */
export interface ReportPeriod {
    dateFrom?: number
    dateTo?: number
}

const periodParams = (p?: ReportPeriod) => ({
    date_from: p?.dateFrom,
    date_to: p?.dateTo,
})

export const PublicReportService = {
    /** Калькулятор на главной: доходность и параметры публичных инструментов.
     *  Без axiosInstance — сбой не должен показывать посетителю уведомление. */
    getRobots: () =>
        instance
            .get<PublicRobotsModel>(`/${PUBLIC_REPORT}/robots`)
            .then(res => res.data),

    /** Курс RCC в $ — по нему робот списывает комиссию. */
    getRccPrice: () =>
        instance
            .get<RccPriceModel>(`/${PUBLIC_REPORT}/rcc-price`)
            .then(res => res.data),

    /** Сводка по всем биржам за всё время */
    getExchanges: (period?: ReportPeriod) =>
        axiosInstance<ExchangeSummaryModel[]>(
            instance.get(`/${PUBLIC_REPORT}/exchanges`, {
                params: periodParams(period),
            })
        ),

    /** Итог по одной бирже */
    getSummary: (exchange: string, period?: ReportPeriod) =>
        axiosInstance<ExchangeSummaryModel>(
            instance.get(`/${PUBLIC_REPORT}/${exchange}/summary`, {
                params: periodParams(period),
            })
        ),

    /** Счета биржи с агрегатами (анонимно) */
    getAccounts: (exchange: string, period?: ReportPeriod, limit = 200) =>
        axiosInstance<AccountSummaryModel[]>(
            instance.get(`/${PUBLIC_REPORT}/${exchange}/accounts`, {
                params: { limit, ...periodParams(period) },
            })
        ),

    /** Помесячная доходность (для графика) */
    getMonthly: (exchange: string, accountId?: number, period?: ReportPeriod) =>
        axiosInstance<MonthlyPointModel[]>(
            instance.get(`/${PUBLIC_REPORT}/${exchange}/monthly`, {
                params: { account_id: accountId, ...periodParams(period) },
            })
        ),

    /** Сделки биржи или конкретного счёта, постранично */
    getDeals: (
        exchange: string,
        skip: number,
        limit: number,
        accountId?: number,
        period?: ReportPeriod
    ) =>
        axiosInstance<BaseSearchResponseModel<PublicDealModel>>(
            instance.get(`/${PUBLIC_REPORT}/${exchange}/deals`, {
                params: {
                    skip,
                    limit,
                    account_id: accountId,
                    ...periodParams(period),
                },
            })
        ),

    /**
     * Прямая ссылка на CSV-выгрузку — её открывает сам браузер, поэтому URL
     * должен быть абсолютным (тот же базовый адрес, что и у axios-инстанса).
     */
    exportCsvUrl: (exchange: string, accountId?: number) =>
        `${BASE_URL_HTTP}/${PUBLIC_REPORT}/${exchange}/export.csv` +
        (accountId ? `?account_id=${accountId}` : ''),
}

const SYMBOL_PROPOSALS = 'symbol-proposals'

/** Свой инструмент клиента: список биржи, расчёт настроек, заявка админу. */
export const SymbolProposalsService = {
    candidates: (exchange: ProposalExchange) =>
        axiosInstance<ProposalCandidateModel[]>(
            instance.get(`/${SYMBOL_PROPOSALS}/${exchange}/candidates`)
        ),

    preview: (exchange: ProposalExchange, data: ProposalBodyModel) =>
        axiosInstance<ProposalPreviewModel>(
            instance.post(`/${SYMBOL_PROPOSALS}/${exchange}/preview`, data)
        ),

    create: (exchange: ProposalExchange, data: ProposalBodyModel) =>
        axiosInstance<ProposalCreatedModel>(
            instance.post(`/${SYMBOL_PROPOSALS}/${exchange}`, data)
        ),

    mine: () =>
        axiosInstance<ProposalRowModel[]>(
            instance.get(`/${SYMBOL_PROPOSALS}/mine`)
        ),

    withdraw: (exchange: ProposalExchange, id: number) =>
        axiosInstance(
            instance.delete(`/${SYMBOL_PROPOSALS}/${exchange}/${id}`)
        ),

    /** Админ: заявки клиентов (сначала на проверке). */
    adminList: (status?: string) =>
        axiosInstance<ProposalRowModel[]>(
            instance.get(`/${SYMBOL_PROPOSALS}/admin`, {
                params: status ? { status } : {},
            })
        ),

    approve: (exchange: ProposalExchange, id: number, note?: string) =>
        axiosInstance(
            instance.post(`/${SYMBOL_PROPOSALS}/${exchange}/${id}/approve`, {
                note,
            })
        ),

    reject: (exchange: ProposalExchange, id: number, note?: string) =>
        axiosInstance(
            instance.post(`/${SYMBOL_PROPOSALS}/${exchange}/${id}/reject`, {
                note,
            })
        ),
}
